import React, { useState } from "react";
import { Box, Link, Tooltip } from "@mui/material";
import { ImageWithFallback } from "../../../helper/helper";
import BlankImg from "../../../assets/images/blank.jpg";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DownloadIcon from "@mui/icons-material/Download";
import styles from "./styles.module.css";
import GlobalVideoViewComponent from "../globalVideoViewComponent/Index";

const Index = ({ link, thumbnail }) => {
  const [view, setView] = useState(false);

  return (
    <>
      <Box className={styles.wrapper}>
        <Box className={styles.p_image}>
          <ImageWithFallback src={thumbnail} alt={""} fallbackSrc={BlankImg} />
          <Box className={styles.playIcon_wrapper}>
            <Tooltip title="Download Video" placement="top">
              <Box
                component={Link}
                href={link}
                target="_blank"
                download={true}
                className={styles.download}
              >
                <DownloadIcon sx={{ color: "white", fontSize: "17px" }} />
              </Box>
            </Tooltip>
            <Tooltip title="View Video" placement="top">
              {/* <Box component={Link} href={link} target="_blank"> */}
              <Box onClick={() => setView(true)}>
                <PlayArrowIcon className={styles.playIcon} />
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      {view && (
        <GlobalVideoViewComponent open={view} setClose={setView} link={link} />
      )}
    </>
  );
};

export default Index;
